import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import { Paper, FormControl, InputLabel, MenuItem, Select, DialogContentText } from '@material-ui/core';

const styles = theme => ({
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  selectTipo: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 5,
    width: 830,
  },
});

class FormDialogEscolherTipo extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      codTipoSelected: 0,
    };
  }
  isSalvarDisabled = () => {
    return this.state.codTipoSelected === 0;
  }
  handleClickSave = async () => {
    await this.props.handleSave(this.state.codTipoSelected);
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  render () {
    const { classes, open, handleClose, titulo } = this.props;
    return (
      <div>
        <Dialog
          disableBackdropClick
          maxWidth='md'
          fullWidth
          open={open}
          onClose={handleClose}
        >
          <DialogTitle>
            {titulo}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              Escolha o Tipo de Acerto que deseja cadastrar
            </DialogContentText>
            <Paper className={classes.body} elevation={1}>
              <FormControl>
                <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipo}>
                  Tipo
                </InputLabel>
                <Select
                  className={classes.selectTipo}
                  value={this.state.codTipoSelected}
                  onChange={this.handleChange}
                  inputProps={{
                    name: 'codTipoSelected',
                  }}
                >
                  {this.props.tipos.map((tipo, idx) => {
                    if (tipo.id !== 1 && tipo.id !== 2 && tipo.id !== 3) {
                      return (<MenuItem key={idx} value={tipo.id}>{tipo.nome.substring(3, tipo.nome.length)}</MenuItem>);
                    }
                  })}
                </Select>
              </FormControl>
            </Paper>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' id={'fechar'}>
              Fechar
            </Button>
            <Button
              disabled={this.isSalvarDisabled()}
              onClick={this.handleClickSave}
              color='primary'>
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default withStyles(styles)(FormDialogEscolherTipo);
